export const iconFontAwesomeUsersPeopleUsersSlash = (
	<i className="fa-solid fa-users-slash"></i>
);
